const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRProgressDraft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-progress-draft",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,1c7.727,0 14,6.273 14,14c-0,7.727 -6.273,14 -14,14c-7.727,-0 -14,-6.273 -14,-14c-0,-7.727 6.273,-14 14,-14Zm-0,2.181c6.523,-0 11.819,5.296 11.819,11.819c0,6.523 -5.296,11.819 -11.819,11.819c-6.523,0 -11.819,-5.296 -11.819,-11.819c-0,-6.523 5.296,-11.819 11.819,-11.819Z",
    style: {
      fill: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.855,13.147l-6.298,6.296c-0.202,0.202 -0.454,0.352 -0.728,0.432l-2.232,0.799c-0.164,0.049 -0.248,0.074 -0.295,0.032c-0.046,-0.042 -0.025,-0.141 0.029,-0.299l0.784,-2.246c0.081,-0.274 0.229,-0.525 0.432,-0.728l6.296,-6.297l2.012,2.011Zm-0.496,-3.529c0.487,-0.487 1.047,-0.446 1.534,0.041l0.453,0.455c0.487,0.486 0.511,1.029 0.025,1.515l-1.077,1.079l-2.011,-2.012l1.076,-1.078Zm7.764,-1.084c0.263,-0.152 0.451,-0.407 0.519,-0.703c0.069,-0.296 0.011,-0.607 -0.158,-0.859c-2.423,-3.446 -6.203,-5.624 -10.41,-5.927c-0.26,-0.014 -0.577,0.103 -0.77,0.282c-0.199,0.184 -0.303,0.475 -0.304,0.783c-0,0.098 -0,-0.024 -0,0.072c0,0.505 0.394,1.011 0.898,1.04c3.521,0.261 6.738,2.091 8.767,4.975c0.32,0.473 0.971,0.642 1.456,0.339c0.007,-0.004 0,-0.001 0.002,-0.002Z",
    style: {
      fill: "#808080"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRProgressDraft);
export default __webpack_public_path__ + "static/media/iconR-progress-draft.588df6fa347fbcc64fe1a6cbe18e917d.svg";
export { ForwardRef as ReactComponent };